export default __webpack_public_path__ + "img/45ef4b4d6f4cd46df18bf49e73f23c01.svg";